"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfMeasurementsError = void 0;
class VcfMeasurementsError extends Error {
    constructor(m) {
        if (!m) {
            m = 'Measurements data cannot be retrieved';
        }
        super(m);
    }
}
exports.VcfMeasurementsError = VcfMeasurementsError;
//# sourceMappingURL=VcfMeasurementsError.js.map